import React, { useRef, useEffect, useLayoutEffect, useState, Fragment } from 'react';
import classNames from 'classnames';

import './header.scss';

export default function Header(prop: any) {

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [size, setSize] = useState([0, 0]);
    const [menuFits, setMenuFits] = useState<boolean>(true);
    
    let a = useRef();
    let refMenu: any = useRef();
    let refLogoutMenu: any = useRef();

    let updateSize = () => {
      setSize([window.innerWidth, window.innerHeight]);
      console.log(refMenu);
      hideMenuIfNeeded();
    };

    let hideMenuIfNeeded = () => {
      const clientRectMenu = refMenu?.getBoundingClientRect();
      const clientRectMenuLogout = refLogoutMenu?.getBoundingClientRect();

      if (clientRectMenu && clientRectMenuLogout) {
        const rightMostEdgeMenu = clientRectMenu.x + clientRectMenu.width;
        const leftMostEdgeMenuLogout = clientRectMenuLogout.x;
        setMenuFits(rightMostEdgeMenu <= leftMostEdgeMenuLogout);
      }
    };

  useLayoutEffect(() => {
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

    useEffect(() => {
      hideMenuIfNeeded();
    }, [size])
  
  const className = classNames({"ui-widget": true, 'ui-widget-hide': !menuFits});
  const env = process.env;
  const link_home = env.REACT_APP_HOME;
  const link_remote_controls = env.REACT_APP_REMOTE_CONTROLS;
  const link_store = env.REACT_APP_STORE;
  const link_data_plans = env.REACT_APP_DATA_PLANS;
  const link_logout = env.REACT_APP_LOGOUT;

  let menu = (
    <div className={className} ref={(ref: any) => refMenu = ref}>
      <a href={link_home} target="_top"><span className="nav-home">Home</span></a>
      <a href={link_remote_controls} target="_top"><span className="nav-remote-controls">Remote Controls</span></a>
      <a href={link_store} target="_top"><span className="nav-store">Store</span></a>
      <a href={link_data_plans} target="_top"><span className="nav-data-plans">Data Plans</span></a>
    </div>
  );

  let logout = (
    <div className="ui-widget2" ref={(ref: any) => refLogoutMenu = ref}>
      <a href={link_logout} target="_top"><span className="nav-log-out">Log Out</span></a>
    </div>
  );

  let navDiv = (
    <div className="landing-nav-bar">
      <div className="landing-nav-bar-layer">
        <div className="themeLogo">
         <a href="/" className="logoLink">
            <div className="landing-nav-var-logo"></div>
          </a>
          {menu}
          {logout}
        </div>
      </div>
    </div>
  );

  return (
    <Fragment>
      {navDiv}
    </Fragment>
  );
  
};
